import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

const TEXT_SEQUENCE = [
  "Creating Loan File structure",
  "Gathering all criteria",
  "Updating capital providers' guidelines",
  "Creating initial Loan terms",
  "Compiling initial Processing list",
];

function CustomProgressBar() {
  const [progress, setProgress] = useState(0);
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const progressTimer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(progressTimer);
          return 100;
        }
        const diff = 100 / ((20 * 1000) / 100); // Calculate progress increment per 100ms
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    return () => {
      clearInterval(progressTimer);
    };
  }, []);

  useEffect(() => {
    const textTimer = setInterval(() => {
      setTextIndex((oldIndex) => (oldIndex + 1) % TEXT_SEQUENCE.length);
    }, 3000);

    return () => {
      clearInterval(textTimer);
    };
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginY: 5,
      }}
    >
      <Typography variant="subtitle1" sx={{ marginBottom: 2 }}>
        {TEXT_SEQUENCE[textIndex]}
      </Typography>
      <Box sx={{ width: "80%" }}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </Box>
  );
}

export default CustomProgressBar;
